"use client";
import style from "./filterSelect.module.scss";
import { FC, ReactNode, useCallback, useMemo, useRef, useState } from "react";
import classnames from "classnames";
import { useTranslation } from "@/src/i18n/client";
import useOptimizedScroll from "@/src/hooks/useOptimizedScroll";
import { FmDrawer, FmIcon, FmRadio } from "@/ui-component";

export interface ISelectProps {
    dataList: FmSelectOptionProps[];
    selectedItem: FmSelectOptionProps;
    onChange: (value: any) => void;
}

export interface IChildren {
    children: ReactNode[];
}

// 选项数据结构
export type FmSelectOptionProps = {
    id: number;
    title: string;
};

const FilterSelectNew: FC<ISelectProps> = (props) => {
    const { selectedItem, dataList, onChange } = props;
    const selectRef = useRef<HTMLDivElement | null>(null);
    const [isShowPanel, setIsShowPanel] = useState<boolean>(false);

    const togglePanel = () => {
        setIsShowPanel(!isShowPanel);
    };

    const handleScroll = useCallback(() => {
        setIsShowPanel(false);
    }, []);
    useOptimizedScroll({ onScroll: handleScroll });

    const selectOnChange = useCallback(
        (value: any) => {
            console.log("selectOnChange", value);
            const result = dataList.find((item) => item.id == value);
            onChange(result);
            setIsShowPanel(false);
        },
        [dataList, onChange],
    );
    const { t } = useTranslation("specialSub");

    return (
        <div
            ref={selectRef}
            className={classnames(style["filter-select-container"])}
        >
            <div>{t("Sortby")}</div>
            <div onClick={togglePanel} className={style["title"]}>
                {t(selectedItem.title)}
                <FmIcon
                    icon="icon--arrow-right"
                    style={{ fontSize: "0.32rem", marginLeft: "0.2rem" }}
                />
            </div>

            <FmDrawer
                onClose={togglePanel}
                open={isShowPanel}
                anchor={"bottom"}
            >
                <FmRadio
                    style={{ width: "100%" }}
                    dataSource={dataList.map((item) => {
                        return {
                            label: t(item.title),
                            value: item.id,
                            formControlLabelClassName: style["select-label"],
                        };
                    })}
                    value={selectedItem.id}
                    onChange={(e, v) => selectOnChange(v)}
                    type="circle"
                    formControlProps={{
                        classes: {
                            root: style["select-container"],
                        },
                    }}
                ></FmRadio>
            </FmDrawer>
        </div>
    );
};

export default FilterSelectNew;
